<!-- HERO SECTION CORPORATIVO -->
<header
  class="hero-section text-center text-white d-flex align-items-center"
  role="banner"
  aria-label="Presentación corporativa"
>
  <div class="container">
    <!-- Título principal -->
    <h1 class="display-5 fw-bold mb-3" itemprop="headline">
      Soluciones Industriales en
      <span class="text-warning" itemprop="keywords">Espuma de Poliuretano</span><br />
      para el Sector Empresarial, centros comerciales
    </h1>

    <!-- Subtítulo corporativo -->
    <p class="lead mb-5" itemprop="description">
      Más de 20 años siendo el proveedor confiable de empresas líderes en múltiples industrias.
    </p>

    <!-- Estadísticas corporativas -->
    <div
      class="row justify-content-center g-4"
      itemscope
      itemtype="https://schema.org/Organization"
    >
      <div class="col-6 col-md-4">
        <div class="stat-box p-4 bg-white rounded shadow-sm">
          <h2 class="fw-bold text-dark" itemprop="yearsActive">20+</h2>
          <p class="text-muted mb-0">Años en el Mercado Industrial</p>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="stat-box p-4 bg-white rounded shadow-sm">
          <h2 class="fw-bold text-dark" itemprop="numberOfEmployees">50+</h2>
          <p class="text-muted mb-0">Empresas Cliente</p>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="stat-box p-4 bg-white rounded shadow-sm">
          <h2 class="fw-bold text-dark">10+</h2>
          <p class="text-muted mb-0">Soluciones Industriales</p>
        </div>
      </div>
    </div>
  </div>
</header>

<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!-- NUESTRA HISTORIA -->
<section id="historia" class="py-5 bg-light" itemscope itemtype="https://schema.org/AboutPage">
  <div class="container">
    <h2 class="display-4 fw-bold text-center" itemprop="headline">Nuestra Historia</h2>
    <div class="row align-items-center g-4">
      <!-- Columna izquierda: Imagen -->
      <div class="col-lg-6">
        <img
          src="assets/principal.png"
          alt="Fábrica y equipo de Pegaespumas - más de 20 años de experiencia en espuma de poliuretano"
          class="img-fluid rounded shadow"
          itemprop="image"
        />
      </div>

      <!-- Columna derecha: Texto -->
      <div class="col-lg-6">
        <h3 class="text-dark mb-4" itemprop="description">
          Con más de dos décadas de experiencia, somos el proveedor líder en soluciones de espuma de
          poliuretano para empresas
        </h3>
        <p class="mb-4" itemprop="text">
          Fundada en 2003, Pegaespumas comenzó como un taller especializado en cortes de espuma. Hoy
          somos fabricantes de productos hechos con espuma de poliuretano para soluciones
          empresariales en construcción, retail, hotelería y más.
        </p>
        <p class="mb-5" itemprop="text">
          Nuestra misión es crear productos que optimicen procesos, mejoren la seguridad y agreguen
          valor a las operaciones de nuestros clientes empresariales.
        </p>

        <!-- Valores Corporativos -->
        <div class="row g-3" itemscope itemtype="https://schema.org/ItemList">
          <div class="col-6">
            <div
              class="d-flex align-items-start"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
            >
              <i class="bi bi-patch-check-fill fs-3 me-2" aria-hidden="true"></i>
              <div>
                <h4 class="fw-semibold mb-1" itemprop="name">Calidad Certificada</h4>
                <small class="text-muted" itemprop="description"
                  >Productos Hechos con los mejores materiales del Mercado</small
                >
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="d-flex align-items-start"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
            >
              <i class="bi bi-recycle fs-3 me-2" aria-hidden="true"></i>
              <div>
                <h4 class="fw-semibold mb-1" itemprop="name">Sostenibilidad</h4>
                <small class="text-muted" itemprop="description"
                  >Usamos Procesos que impiden un desperdicio de material</small
                >
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="d-flex align-items-start"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
            >
              <i class="bi bi-lightbulb-fill fs-3 me-2" aria-hidden="true"></i>
              <div>
                <h4 class="fw-semibold mb-1" itemprop="name">Innovación Constante</h4>
                <small class="text-muted" itemprop="description"
                  >Continuo para soluciones empresariales.</small
                >
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="d-flex align-items-start"
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
            >
              <i class="bi bi-people-fill fs-3 me-2" aria-hidden="true"></i>
              <div>
                <h4 class="fw-semibold mb-1" itemprop="name">Equipo Experto</h4>
                <small class="text-muted" itemprop="description"
                  >Especialistas en soluciones industriales.</small
                >
              </div>
            </div>
          </div>
        </div>
        <!-- Fin valores -->
      </div>
    </div>
  </div>
</section>

<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!-- NUESTROS PRODUCTOS -->
<section id="Productos" class="container py-5" itemscope itemtype="https://schema.org/ItemList">
  <div class="row">
    <div class="col-12 text-center mb-5">
      <h2 class="display-4 fw-bold" itemprop="name">Nuestros Productos</h2>
      <p class="lead mt-3" itemprop="description">
        Productos de espuma de poliuretano diseñados para las necesidades específicas del sector
        empresarial
      </p>
    </div>
  </div>

  <div class="row g-4">
    <!-- Colchones Premium -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/colchon/principal.png"
            class="product-image"
            alt="Colchones de espuma de poliuretano para hotelería - máxima comodidad y soporte"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Colchones
            </a>
          </h3>
          <p class="card-text" itemprop="description">
            Nuestra línea de colchones combina tecnología de vanguardia con materiales de primera
            calidad para ofrecer el máximo confort y soporte. Diseñados para adaptarse a las
            necesidades específicas de cada usuario, nuestros colchones garantizan un descanso
            reparador.
          </p>
        </div>
      </div>
    </div>

    <!-- Parques Infantiles -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/parques/principal.png"
            class="product-image"
            alt="parques infantiles para centros comerciales bogota"
            itemprop="image"
          /><!-- la clase debe aplicarse atodas las imagenes principales-->
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Parques Infantiles
            </a>
          </h3>
          <p class="card-text" itemprop="description">
            Nuestros parques infantiles están diseñados con seguridad como prioridad. Utilizamos
            materiales de alta resistencia y superficies acolchonadas para crear espacios de juego
            donde los niños pueden explorar y divertirse sin riesgos.
          </p>
        </div>
      </div>
    </div>

    <!-- Colchonetas Deportivas -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/colchonetas/principal.png"
            class="product-image"
            alt="Colchonetas deportivas de alta densidad - superficie antideslizante para gimnasios en bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/productos"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Colchonetas
            </a>
          </h3>
          <p class="card-text" itemprop="description">
            Nuestras colchonetas versátiles son ideales para yoga, pilates, ejercicios en casa o
            como solución de descanso ocasional. Fabricadas con materiales de alta densidad que
            ofrecen comodidad.
          </p>
        </div>
      </div>
    </div>

    <!-- Parasoles  -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/parasoles/principal.png"
            class="product-image"
            alt="Parasoles- protección solar bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Parasoles
            </a>
          </h3>
          <p class="card-text" itemprop="description">
            Ideal para cafeterías, terrazas y jardines, nuestros parasoles ofrecen sombra efectiva y
            resistencia al clima. Su diseño funcional protege del sol sin comprometer el estilo del
            entorno.
          </p>
        </div>
      </div>
    </div>

    <!-- Puffs Modulares -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/puff/principal.png"
            class="product-image"
            alt="Mobiliario corporativo en bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Puff</a
            >
          </h3>
          <p class="card-text" itemprop="description">
            Los puffs son una solución funcional y estilizada para cualquier ambiente. Ofrecemos
            modelos fijos y moldeables que se ajustan a la forma del cuerpo y aportan un toque
            moderno al espacio.
          </p>
        </div>
      </div>
    </div>

    <!-- Almohadas Ortopédicas -->
    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/almohada/principal.png"
            alt="Almohada principal"
            class="product-image"
            alt="Almohadas terapéuticas para bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Almohadas para Hotelería</a
            >
          </h3>
          <p class="card-text" itemprop="description">
            Ofrecemos almohadas diseñadas para brindar confort y soporte ergonómico. Nuestras
            espumas de alta calidad se adaptan a la forma del cuerpo y ayudan a mejorar la calidad
            del descanso.
          </p>
        </div>
      </div>
    </div>
    <!--Tapiceria muebles-->

    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/tapiceria/principal.png"
            class="product-image"
            alt="tapiceria de muebles en bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Tapiceria Muebles</a
            >
          </h3>
          <p class="card-text" itemprop="description">
            Transforme sus muebles con nuestros sistemas de tapicería de alta calidad. Ofrecemos
            soluciones para sofás, sillas, cabeceros y cualquier tipo de mobiliario que requiera
            renovación o mejoras en el confort.
          </p>
        </div>
      </div>
    </div>
    <!--Saltarines-->

    <div
      class="col-md-6 col-lg-4"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/Product"
    >
      <div class="card product-card h-100 border-0 shadow-sm">
        <div class="product-image-container overflow-hidden">
          <img
            src="https://ragde39.github.io/cdn_es/productos/saltarin/principal.png"
            class="product-image"
            alt="salatarines centros comerciales bogota"
            itemprop="image"
          />
        </div>
        <div class="card-body">
          <h3 class="card-title" itemprop="name">
            <a
              routerLink="/producto"
              class="text-decoration-none fw-bold product-title"
              itemprop="url"
              >Saltarines</a
            >
          </h3>
          <p class="card-text" itemprop="description">
            Nuestros saltartines están pensados para combinar diversión y seguridad. Incorporan
            bases flexibles que absorben impacto y permiten un rebote controlado para todas las
            edades.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!-- NUESTROS CLIENTES -->
<section id="clientes" class="py-5 bg-light" itemscope itemtype="https://schema.org/ItemList">
  <div class="container">
    <div class="col-12 text-center mb-5">
      <h2 class="display-4 fw-bold" itemprop="name">Clientes Corporativos</h2>
      <p class="lead mt-3" itemprop="description">
        Empresas líderes que confían en nuestras soluciones
      </p>
      <div class="divider my-4"></div>
    </div>

    <div class="row g-4 text-center">
      <!-- Card 1 -->
      <div
        class="col-md-6 col-lg-3"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <div class="icon-circle mb-3">
              <i class="bi bi-tv fs-1" aria-hidden="true"></i>
              <!--text- es el color del icono-->
            </div>
            <h3 class="fw-bold h5" itemprop="name">Caracol El Desafío</h3>
            <p class="text-muted small" itemprop="description">
              Suministramos espumas de seguridad para los sets de grabación de este famoso programa
              de televisión.
            </p>
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div
        class="col-md-6 col-lg-3"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <div class="icon-circle mb-3">
              <i class="bi bi-cart4 fs-1" aria-hidden="true"></i>
            </div>
            <h3 class="fw-bold h5" itemprop="name">Centro Comercial Fontanar</h3>
            <p class="text-muted small" itemprop="description">
              Instalación de parasoles técnicos y mobiliario en espuma para sus zonas comunes y
              terrazas.
            </p>
          </div>
        </div>
      </div>

      <!-- Card 3 -->
      <div
        class="col-md-6 col-lg-3"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <div class="icon-circle mb-3">
              <i class="bi bi-building fs-1" aria-hidden="true"></i>
            </div>
            <h3 class="fw-bold h5" itemprop="name">Centro Comercial El Tintal</h3>
            <p class="text-muted small" itemprop="description">
              Diseño e instalación de parques infantiles y áreas de descanso con espumas de alta
              densidad.
            </p>
          </div>
        </div>
      </div>

      <!-- Card 4 -->
      <div
        class="col-md-6 col-lg-3"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/Organization"
      >
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body">
            <div class="icon-circle mb-3">
              <i class="bi bi-hospital fs-1" aria-hidden="true"></i>
            </div>
            <h3 class="fw-bold h5" itemprop="name">Hoteles Nacionales</h3>
            <p class="text-muted small" itemprop="description">
              Proveedores oficiales de colchones y almohadas para cadenas hoteleras en todo el país.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!--&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&-->
<!-- CONTACTO -->

<div class="col-12 text-center mb-5">
  <h2 class="display-4 fw-bold" itemprop="name">Contactenos</h2>
</div>

<div class="container p-0">
  <div class="row g-3">
    <!-- Mapa -->
    <div class="col-md-6 d-flex align-items-center justify-content-center">
      <div class="w-100" style="max-width: 500px">
        <div class="ratio ratio-4x3">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.635750877932!2d-74.0730408265065!3d4.658871742021846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9a518fb63c13%3A0xda3d7e92b141ec82!2sPEGAESPUMAS!5e0!3m2!1ses!2sco!4v1762139494921!5m2!1ses!2sco"
            class="w-100 h-100"
            style="border: 0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <!-- Componente Angular -->
    <div class="col-md-6">
      <div
        class="p-3 bg-white h-100 border-0 d-flex align-items-center justify-content-center"
        style="border: none; box-shadow: none"
      >
        <app-contacto></app-contacto>
      </div>
    </div>
  </div>
</div>
<!----->
<!---->
